// extracted by mini-css-extract-plugin
module.exports = {"heading":"index__heading___3C9Nv container__container___FpQXl"};